export default __webpack_public_path__ + "static/media/MontserratAlternates-Bold.bf8eb3e8.ttf";